import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { WebComponent } from './web/web.component';
import { TermsComponent } from './terms/terms.component';
import { TermsPacComponent } from './terms-pac/terms-pac.component';
import { TermsSatComponent } from './terms-sat/terms-sat.component';
import { PolicyComponent } from './policy/policy.component';

const routes: Routes = [
    {
        path: '',
        component: WebComponent,
    }

    , {
        path: 'login/:id',
        component: WebComponent
      }, {
        path: 'login/:id/:languaje',
        component: WebComponent
      },


    {
        path: 'terms',
        component: TermsComponent,
    },
    {
        path: 'termspac',
        component: TermsPacComponent,
    },
    {
        path: 'termssat',
        component: TermsSatComponent,
    },
    {
        path: 'policy',
        component: PolicyComponent,
    },
    {
        path: '',
        loadChildren: './pages/pages.module#PagesModule'
    },
    { path: '**', redirectTo: '' }
];

@NgModule({
    imports: [RouterModule.forRoot(routes), NgbModule.forRoot()],
    exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts